import { render, staticRenderFns } from "./ed-create-staff.component.vue?vue&type=template&id=7a453536&scoped=true&"
import script from "./ed-create-staff.component.ts?vue&type=script&lang=ts&"
export * from "./ed-create-staff.component.ts?vue&type=script&lang=ts&"
import style0 from "./ed-create-staff.component.scss?vue&type=style&index=0&id=7a453536&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7a453536",
  null
  
)

export default component.exports